import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 384,
      margin: '0 auto',
    },
    icon: {
      color: ({ secondaryColor }) => secondaryColor,
    },
    collapsible: {
      '& .MuiCollapse-wrapper': {
        padding: '20px 10px',
        [theme.breakpoints.up('sm')]: {
          padding: '20px 0',
        },
      },
    },
    formRow: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 20,
      gap: 20,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    paymentMethodTabs: {
      marginTop: 20,
      marginBottom: 20,

      '& .MuiTabs-fixed': {
        '& button': {
          marginLeft: 10,
          [theme.breakpoints.up('sm')]: {
            marginLeft: 20,
          },
        },
        '& button:first-child': {
          marginLeft: 0,
        },
      },
    },
    tab: {
      minWidth: 'auto',
      maxWidth: '50%',
      minHeight: 66,
      border: 'solid 1px',
      borderColor: '#014651',
      borderRadius: 10,
      textAlign: 'right',
      '&.Mui-selected': {
        borderColor: ({ primaryColor }) => primaryColor,
      },
      '& .MuiTab-wrapper': {
        alignItems: 'start',
      },
    },
    hide: {
      display: 'none',
    },
    formLabelControlContainer: {
      padding: '12px 10px',
      backgroundColor: '#F5F5F5',
      borderRadius: 8,
    },
    formLabelControl: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.oysterTheme.pine,
    },
  }),
);

export default useStyles;
